import React, { PropTypes } from 'react';
import VisibilitySensor from 'react-visibility-sensor';

class VideoTag extends React.Component {
  constructor(props) {
    super(props);
    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
  }

  onVisibilityChange(isVisible) {
    if (isVisible) {
      this.play();
    } else {
      this.pause();
    }
  }

  play() {
    this.video.play();
  }

  pause() {
    this.video.pause();
  }


  render() {
    const { value: { storlek, style, poster, src, sources, loop = true, preload = 'none', className } } = this.props;
    const styles = require('./styles.scss');
    const size = require('styleTools/SizeClasses.scss');
    const sizeClass = (storlek && size[storlek]) || size.textblock;
    const classes = className || styles.mod_default + ' ' + sizeClass;
    return (
      <VisibilitySensor
        onChange={this.onVisibilityChange}
        partialVisibility={true}
      >
        <video
          className={classes}
          style={style}
          preload={preload}
          poster={poster}
          src={src}
          playsInline
          muted
          loop={Boolean(loop !== 'false')}
          ref={(video) => { this.video = video; }}
        >
          { sources.map((s, i) =>
            <source key={i} src={s.value} type={`video/${s.type}`} />
          )}
        </video>
      </VisibilitySensor>

    );
  }
}


VideoTag.propTypes = {
  modifiers: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  poster: PropTypes.string,
  src: PropTypes.string,
  sources: PropTypes.array,
  loop: PropTypes.bool,
  preload: PropTypes.string,
  className: PropTypes.string
};

export default VideoTag;


//
// {.videobg}
// style.height: 40vh
// style.maxHeight: 600px
// style.marginTop:0
// mod:full
//   [.+content]
// {.div}
// style.marginTop:0
// style.height:100%
// mod:bred
//   [.+content]
// {.rubrik}
// style.position: absolute
// style.bottom:12px
// mod:xl,vit, center
// rubrik:Lorem ipsum dolor sit amet
// {}
//
// []
// {}
// []
// {}



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/VideoTag/VideoTag.js
 **/